const menuItemLinksStyles = (theme) => ({
  textWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 17,
    minWidth: 0,
  },
  itemText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  divider: {
    margin: '8px 16px',
  },
  // Lines up with the menu items below it: same padding, icon size, gap and font.
  sectionLabel: {
    ...theme.typography.body1,
    display: 'flex',
    alignItems: 'center',
    gap: 17,
    padding: '1.3vh 1.7vh 0.5vh 18px',
    fontWeight: 700,
    color: '#555555',
    '& svg': { flexShrink: 0 },
  },
})

export default menuItemLinksStyles
